import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { SessionStorageService } from '../../shared-services/services/session-storage.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {
    constructor(
        private router: Router,
        private authService: AuthService,
        private sessionStorageService: SessionStorageService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {

        if (state.url) {
            const urlTree = this.router.parseUrl(state.url || '');
            const code = urlTree.queryParamMap.get('code');

            if (code) {
                return this.authService.getB2CTokens(code).pipe(
                    map(() => {
                        return this.handleAuthorized(state);
                    }),
                    catchError(() => {
                        return of(false);
                    })
                );
            }
        }

        return this.handleAuthorized(state);
    }

    private handleAuthorized(state: RouterStateSnapshot): boolean {

        if (this.authService.isAuthenticated()) {
            if (this.sessionStorageService.isLockerLiteUser()) {
                this.router.navigate(['lender-connect']);
                return false;
            } else {
                return true;
            }

        } else {
            // if coming from mobile app to change password
            if (state.url.endsWith('password-reset')) {
                this.router.navigate(['password-reset'], {
                    queryParams: { returnUrl: state.url },
                    queryParamsHandling: 'merge'
                });
                return true;
            }

            // not logged in so redirect to login page with the return url
            if (!this.authService.isSsoInProgress) {
                this.router.navigate(['login'], { queryParams: { returnUrl: state.url }, queryParamsHandling: 'merge' });
            }
            return false;
        }
    }
}
